export const status = {
  NO_STATUS: 'NO_STATUS',
  NSFW: 'NSFW',
  SFW: 'SFW',
};
